export const firebaseConfig = {
  apiKey: "AIzaSyDUys1pyJ4Mw_zZ_Nk5WZgmlYoebV0fvtw",
  authDomain: "redatwater.firebaseapp.com",
  databaseURL: "https://redatwater-default-rtdb.firebaseio.com",
  projectId: "redatwater",
  storageBucket: "redatwater.firebasestorage.app",
  messagingSenderId: "290654955570",
  appId: "1:290654955570:web:f40807b819b7f545bbb42b",
  measurementId: "G-BVQBBS723L"
};